"use client";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import CustomInput from "@/components/shared/CustomInput";
import Image from "next/image";
import search from "@/public/images/search.svg";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";
import TelegramLogin from "@/components/HomeComponents/TelegramLogin";
import AdPannerFooter from "@/components/shared/AdPannerFooter/AdPannerFooter";
import TeacherCard from "@/components/shared/TeacherCard";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import GENERAL, { SelectSchoolYears } from "@/redux/GENERAL";
import USER, { SelectTeachers } from "@/redux/User";
import SocialMedia from "@/components/shared/socialMedia/SocialMedia";
import { SelectLoggedUser } from "@/redux/Auth";
import { useSearchParams } from "next/navigation";
import Link from "next/link";
import useCreateQueryString from "@/hooks/useCreateQueryString";
import { X } from "lucide-react";
import MyLink from "@/components/shared/myLink/MyLink";
import PaginationControls from "@/components/shared/PaginationControls";

const InstructorsPage = () => {
  const dispatch = useAppDispatch();
  const [page, setpage] = useState(1);
  const [schoolYearSelected, setschoolYearSelected] = useState<any>([]);
  const [searchValue, setsearchValue] = useState("");
  const [teachers, setTeachers] = useState<any[]>([]);

  const schoolYear = useAppSelector(SelectSchoolYears);

  const teachersData = useAppSelector(SelectTeachers);
  const loggedUser = useAppSelector(SelectLoggedUser);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchSchoolYears = async () => {
      const params =
        loggedUser?.isLoggedIn && loggedUser?.userToken
          ? {
              mainEducationType:
                loggedUser?.userData?.details?.type_education?.id,
            }
          : {};

      await dispatch(GENERAL.thunks.doGetSchoolYears(params));
    };

    fetchSchoolYears();
  }, [dispatch, loggedUser]);

  // useEffect(() => {
  //   dispatch(
  //     USER.thunks.doGetTeachers({
  //       search: searchValue,
  //       school_years: schoolYearSelected,
  //     })
  //   );
  // }, [searchValue, schoolYearSelected]);

  useEffect(() => {
    dispatch(
      USER.thunks.doGetTeachers({
        search: searchValue,
        school_years: schoolYearSelected,
        page: currentPage,
      })
    )
      .then((res) => {
        setTotalPages(res.payload.data.total_pages);
      })
      .finally(() => {});
  }, [schoolYearSelected, searchValue, currentPage, dispatch]);

  const handlePageChange = (selectedItem: { selected: number }) => {
    setCurrentPage(selectedItem.selected + 1);
  };

  const searchParams = useSearchParams();
  const subjectID = searchParams.get("subject_id");

  useEffect(() => {
    if (subjectID && teachersData) {
      setTeachers(
        teachersData?.filter((el: any) => {
          return String(el?.subject?.id) === subjectID;
        })
      );
    } else {
      setTeachers(teachersData);
    }
  }, [subjectID, teachersData]);

  const { pathname } = useCreateQueryString();

  return (
    <div>
      <Header />
      <div className="container my-10 flex flex-col gap-10">
        <div className="bg-[#323538] rounded-[20px] p-3 flex flex-col gap-5">
          <div className="flex items-center bg-[#474A4D] rounded-[5px] py-2 pl-3">
            <Formik
              initialValues={{ search: "" }}
              onSubmit={(values) => {
                setsearchValue(values.search);
              }}
            >
              {(props) => (
                <Form className="w-full flex justify-between gap-4">
                  <CustomInput
                    type="text"
                    name="search"
                    placeholder="بحث عن مدرس في المنصة"
                    fullWidth={true}
                  />
                  <button type="submit">
                    <Image src={search as string} alt="search" />
                  </button>
                </Form>
              )}
            </Formik>
          </div>
          <div className="flex gap-5 flex-wrap">
            {schoolYear.map((year: any, i: number) => (
              <button
                onClick={(e) => {
                  schoolYearSelected.includes(year.id)
                    ? setschoolYearSelected((prev: any) =>
                        prev.filter((item: any) => item !== year.id)
                      )
                    : setschoolYearSelected((prev: any) => [...prev, year.id]);
                }}
                className={`${
                  schoolYearSelected.includes(year.id)
                    ? "bg-primaryColor text-black"
                    : "bg-[#474A4D] text-white"
                } rounded-[5px] text-14 w-fit py-3 px-5`}
                key={i}
              >
                {year.name}
              </button>
            ))}
          </div>
        </div>
        {subjectID && (
          <MyLink href={pathname} className="w-fit">
            <div className="flex items-center gap-3 text-primaryColor">
              <X size={16} />
              <span>إعادة تعيين</span>
            </div>
          </MyLink>
        )}
        {teachers.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-5">
            {teachers.map((teacher: any, i: number) => (
              <TeacherCard
                key={i}
                image={teacher?.image}
                subject={teacher?.subject?.name}
                teacherName={teacher?.name}
                description={teacher.description}
                id={teacher?.id}
                schoolYears={teacher?.school_years}
                full={true}
              />
            ))}
          </div>
        ) : (
          <div className="text-center text-red-400 bg-[#474A4D] rounded-[5px] py-5 px-3">
            <p>لم يتم العثور على أي معلمين بناءً على الفلاتر المطبقة.</p>
          </div>
        )}
        {/* <Pagination
          page={page}
          setpage={setpage}
          numberOfPages={10}
        /> */}
        <PaginationControls
          currentPage={currentPage}
          totalQuestions={totalPages * 10}
          questionsPerPage={10}
          onPageChange={handlePageChange}
        />
      </div>
      <SocialMedia />
      <Footer />
      <TelegramLogin />
      {/* <AdPannerFooter /> */}
    </div>
  );
};

export default InstructorsPage;
